import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { OperativeUnitDto } from "@/core/features/operative-units/operative-unit.dto";
import { Type } from "class-transformer";

export class InvoiceLineDto extends BaseEntityDto {
  intervention: string;

  text: string;

  quantity: number;

  operativeUnitId?: string | null;

  @Type(() => OperativeUnitDto)
  operativeUnit?: OperativeUnitDto | null;

  position: number;
}
